// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".guide-list .heading[data-v-786e0ed8]{margin:0 0 16px;font-weight:700;text-transform:uppercase;font-size:16px;color:#6a7c8f}.guide-list ul[data-v-786e0ed8]{margin:0;padding:0;list-style:none;display:flex;flex-direction:column;gap:32px}.guide-list.inline ul[data-v-786e0ed8]{height:auto;flex-direction:row;gap:16px}.guide-list.inline ul li[data-v-786e0ed8]{min-width:320px;width:320px}", ""]);
// Exports
module.exports = exports;
